import styled from "styled-components"
import { IconButton } from "@mui/material"
//import Logo from "../../images/logo.png"

export const Wrapper = styled.nav`
  width: ${({ theme }) => theme.navWidth}px;
  background-color: ${({ theme }) => theme.palette.primary.main};
  transition: padding-top 0.3s ease, padding-bottom 0.3s ease,
    background-color 0.3s ease;

  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 100%;
    position: fixed;
    z-index: 10;

    .first {
      margin: 0.5em 2em;
    }
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    .first {
      width: ${({ theme }) => theme.navWidth}px;
      height: 100vh;
      position: fixed;
      flex-direction: column;
      padding: 1em 0;

      ul {
        margin: 0;
        padding: 0 !important;
      }
    }
  }

  .first {
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow-y: auto;

    ul {
      padding: 0 !important;
      margin: 0;
    }
  }
`

export const Logo = styled.div`
  text-align: center;

  img {
    max-width: 140px;

    ${({ theme }) => theme.breakpoints.down("md")} {
      max-width: 50px;
    }
  }
`

/*export const CustomLogo = styled(Logo)`
  width: 300px;
  height: 50px;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    width: 200px;
  }
`*/

export const Item = styled.li`
  text-align: center;
  list-style: none;
  text-transform: uppercase;
  margin: 0.5em 0;

  a {
    font-weight: 500;
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    color: #ffffff;
    opacity: 0.75;
    text-decoration: none;
    opacity: ${({ slug }) => (slug ? "1" : "0.75")};

    &:hover,
    &.active {
      font-weight: 700;
      opacity: 1;
    }
  }
`

export const RightItems = styled.div`
  display: flex;
  margin-left: auto;
`

export const MenuBtn = styled(IconButton)`
  border: 1px solid #ffffff;
  padding: 0.25em;
  border-radius: 0;

  .MuiSvgIcon-root {
    fill: #ffffff;
  }
`

export const Description = styled.div`
  text-align: center;
  color: #ffffff;

  h2 {
    margin-bottom: 0.5em;
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  }

  .phone {
    display: block;
    margin-top: 0;
    margin-bottom: 1em;
    color: #ffffff;
    text-decoration: none;
    font-weight: 400;
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};
  }

  .address {
    margin-bottom: 0.5em;
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    opacity: 0.75;

    span {
      font-weight: 500;
    }
  }

  .social-media {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: #ffffff;
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    opacity: 0.75;

    p {
      margin-right: 0.5em;
    }
  }
`
